export enum RoutePointType {
	HOTEL = "HOTEL",
	AIRPORT = "AIRPORT",
	PLACE = "PLACE"
}
